import React, { Fragment, useEffect, useState } from 'react'
import creditCardType from 'credit-card-type'
import Loader from 'react-loader-spinner'
import isEmpty from 'lodash/isEmpty'
import first from 'lodash/first'
import CardBrand from '../../../../../assets/CardBrand.png'
import GeneralInput from '../../../../../components/GeneralInput'
import GeneralInputMask from '../../../../../components/GeneralInputMask'
import SelectInput from '../../../../../components/SelectInput'
import CreditCardRefused from '../../../../../assets/CreditCardRefused.png'
import months from './months'
import years from './years'
import VisaCard from '../../../../../assets/visa-logo.png'
import MasterCard from '../../../../../assets/mastercard-logo.png'
import Pay from '../../../../../assets/pay.png'
import {
  getUserCreditcards,
  // deleteCreditCardById
} from '../../../../../services/credit-card'

import './style.scss'
import ErrorComponent from 'components/ErrorComponent'
import COLORS from 'styles/colors'
import { cepMask, creditCardMask } from 'constants/masks'

const maskCreditCardNumbers = (cardNumber) => {
  const regex = /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/g
  const onlyNumbers = cardNumber.replace(/[^\d]/g, '')

  const replacedCard = onlyNumbers.replace(regex, (regex, $1, $2, $3, $4) =>
    [$1, $2, $3, $4].filter((group) => !!group).join(' '),
  )

  return replacedCard.slice(0, 4) + replacedCard.slice(4).replace(/\d(?=.* )/g, '*')
}

const checkCreditCardBrand = (cardNumber) => {
  const visaCards = creditCardType(cardNumber.slice(0, 4))
  return first(visaCards).type === 'mastercard' ? MasterCard : VisaCard
}

const CreditPayment = ({
  isLoading,
  isLoadingVoucher,
  saveCreditCardNumber,
  userId,
  success,
  error,
  payment,
  voucher,
  holderName,
  creditCardNumber,
  postalCode,
  addressNumber,
  ccv,
  expiryMonth,
  expiryYear,
  city,
  stateAddress,
  cep,
  onPrevious,
  handlePurchase,
  handleVoucher,
  handleSaveCreditCard,
}) => {
  const [creditCardInfo, setCreditCardInfo] = useState({ secondPurchase: true })
  const [creditCardList, setCreditCardList] = useState([])
  const [addCreditCard, setAddCreditCard] = useState(false)
  const [isChecked, setIsChecked] = useState({})
  const token = localStorage.getItem('accessToken')

  useEffect(() => {
    getUserCreditcards(userId, token)
      .then((res) => {
        setCreditCardList(res.data)
      })
      .catch((err) => console.log('Err => getUserCreditcards'))
  }, [creditCardInfo, token, userId])

  // const handleDelteCreditCard = (id) => {
  //   deleteCreditCardById(id)
  //   .then(() => {
  //     setCreditCardList([...creditCardList, creditCardList.filter(card => card.id !== id)])
  //   })
  //   .catch((err) => console.log('Error => handleDelteCreditCard'))
  // }

  return (
    <Fragment>
      {payment && (
        <div>
          {Boolean(error) && (
            <div style={{ marginTop: 16 }}>
              <ErrorComponent errors={[error]} />
            </div>
          )}

          {Boolean(success) && (
            <div
              style={{
                background: COLORS.brand.primary,
                width: '100%',
                padding: 16,
                borderRadius: 6,
              }}
            >
              <p style={{ color: '#fff', textAlign: 'center', margin: 16 }}>{success}</p>
            </div>
          )}
          <div className='payment'>
            <div className='payment_taxvalue'>
              <div>
                <div className='payment_taxlabel'>Total</div>
                <div className='payment_taxtext'>R$25,00</div>
              </div>
            </div>

            <div className='payment_message'>
              <div className='payment_message_title'>Possui um Voucher?</div>
              <div className='payment_message_text'>Insira abaixo o seu Voucher</div>
              <div className='payment_message_text'>e ganhe uma avaliação gratuita!</div>
            </div>

            <GeneralInput handleChange={voucher} label='Inserir Voucher' />

            {isLoadingVoucher ? (
              <div style={loadingSpinner}>
                <Loader type='Oval' color='#00BFFF' height={60} width={60} style={{ marginTop: '50px' }} />
              </div>
            ) : (
              <div className='payment_group_buttons'>
                <button className='payment_button' onClick={handleVoucher}>
                  Ativar voucher
                </button>
              </div>
            )}
          </div>

          {isEmpty(creditCardList) || addCreditCard ? (
            <div className='payment'>
              <div className='payment_message'>
                <div className='payment_message_title'>Dados do cartão de crédito</div>
                <div className='payment_message_text'>Insira abaixo os dados do seu</div>
                <div className='payment_message_text'>cartão de crédito.</div>
              </div>

              <GeneralInput handleChange={holderName} autocompletetype='cc-name' label='Nome' />

              <GeneralInputMask
                handleChange={creditCardNumber}
                mask={creditCardMask}
                label='Nº do cartão de crédito'
                autocompletetype='cc-number'
              />

              <div className='payment_content_brand'>
                <img src={CardBrand} alt='card-brand' className='payment_brand' />
              </div>

              <div className='payment_csv_content'>
                <div className='payment_csv_text'>
                  <div className='payment_message_text'>Código Segurança</div>
                  <div className='payment_message_text'>(CSC)</div>
                </div>
                <div>
                  <GeneralInput handleChange={ccv} autocompletetype='cc-csc' label='CSC' limit={3} />
                </div>
              </div>

              <div className='payment_expiration_content'>
                <div className='payment_message_text'>Data de vencimento</div>
              </div>
              <div className='payment_expiration_date'>
                <SelectInput style={selectInput} options={months} handleChange={expiryMonth} />
                <SelectInput options={years} handleChange={expiryYear} />
              </div>

              <GeneralInput handleChange={postalCode} label='Endereço de Cobrança' />

              <GeneralInput handleChange={addressNumber} label='Número' />

              <GeneralInput handleChange={city} autocompletetype='' label='Cidade' />

              <GeneralInput handleChange={stateAddress} autocompletetype='' label='Estado/Região' />

              <GeneralInputMask handleChange={cep} mask={cepMask} label='CEP' />

              <div className='payment_checkbox'>
                <input checked={saveCreditCardNumber} type='checkbox' onChange={handleSaveCreditCard} />
                <label className='payment_checkbox_label' htmlFor='creditcard-checkbox'>
                  Deseja salvar essas informações de pagamento
                </label>
              </div>

              {Boolean(error) && (
                <div className='payment_error'>
                  <div className='payment_error_header'>Seu Pagamento não foi aprovado</div>
                  <div className='payment_error_text'>Verifique a sua operadora de cartão</div>
                  <div className='payment_error_text'>ou tente novamente</div>
                  <img className='payment_error_image' src={CreditCardRefused} alt='credit-card-error' />
                </div>
              )}

              <div className='payment_switch'>
                <img src={Pay} className='payment_card-icon ' alt='payment' />
                <span className='payment_card-text' onClick={() => setAddCreditCard(false)}>
                  Usar um cartão <br /> cadastrado.
                </span>
              </div>

              {isLoading ? (
                <div style={loadingSpinner}>
                  <Loader type='Oval' color='#00BFFF' height={60} width={60} style={{ marginTop: '50px' }} />
                </div>
              ) : (
                <div className='payment_group'>
                  <button onClick={onPrevious} className='payment_back'>
                    Voltar
                  </button>
                  <button onClick={handlePurchase} className='payment_purchase'>
                    Efetuar Pagamento
                  </button>
                </div>
              )}

              <div className='payment_message'>
                <div className='payment_message_text'>Após comprovação de pagamento você irá</div>
                <div className='payment_message_text'>acessar a avaliação de crédito</div>
                <div className='payment_message_text'>instantaneamente e também receberá o</div>
                <div className='payment_message_text'>resultado no seu email.</div>
              </div>
            </div>
          ) : (
            <div>
              {creditCardList
                .filter(
                  (card, index, self) =>
                    index === self.findIndex((reference) => reference.number === card.number),
                )
                .map((card) => (
                  <div key={card.id} className='credit_card'>
                    <input
                      type='radio'
                      checked={card.id === isChecked.id}
                      onChange={() => {
                        setIsChecked(card)
                        setCreditCardInfo({ ...creditCardInfo, card })
                      }}
                    />
                    <img src={checkCreditCardBrand(card.number)} className='credit_card_brand' alt='card' />
                    <div className='credit_card_number'>
                      {maskCreditCardNumbers(card.number)} Exp.:{card.expiryMonth}/{card.expiryYear}
                    </div>
                    {/* <span onClick={() => handleDelteCreditCard(card.id)}>X</span> */}
                  </div>
                ))}
              <div className='payment_switch'>
                <img src={Pay} className='payment_card-icon ' alt='payment' />
                <span className='payment_card-text' onClick={() => setAddCreditCard(true)}>
                  Adicionar <br /> novo cartão
                </span>
              </div>
              {Boolean(error) && (
                <div className='payment_error'>
                  <div className='payment_error_header'>Seu Pagamento não foi aprovado</div>
                  <div className='payment_error_text'>Verifique a sua operadora de cartão</div>
                  <div className='payment_error_text'>ou tente novamente</div>
                  <img className='payment_error_image' src={CreditCardRefused} alt='credit-card-error' />
                </div>
              )}

              {isLoading ? (
                <div style={loadingSpinner}>
                  <Loader type='Oval' color='#00BFFF' height={60} width={60} style={{ marginTop: '50px' }} />
                </div>
              ) : (
                <div className='payment_group'>
                  <button onClick={onPrevious} className='payment_back'>
                    Voltar
                  </button>
                  <button
                    onClick={() => {
                      handlePurchase(creditCardInfo, true)
                    }}
                    className='payment_purchase'
                  >
                    Efetuar Pagamento
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </Fragment>
  )
}

const selectInput = {
  marginRight: 12,
}

const loadingSpinner = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
}

// TO DO: ts

// CreditPayment.propTypes = {
//   sucess: PropTypes.bool,
//   isLoding: PropTypes.bool,
//   userId: PropTypes.string,
//   error: PropTypes.bool,
//   payment: PropTypes.bool,
//   voucher: PropTypes.func,
//   holderName: PropTypes.func,
//   creditCardNumber: PropTypes.func,
//   expiryMonth: PropTypes.func,
//   expiryYear: PropTypes.func,
//   ccv: PropTypes.func,
//   postalCode: PropTypes.func,
//   addressNumber: PropTypes.func,
//   city: PropTypes.func,
//   stateAddress: PropTypes.func,
//   cep: PropTypes.func,
//   onPrevious: PropTypes.func,
//   handlePurchase: PropTypes.func,
//   handleVoucher: PropTypes.func,
//   handleSaveCreditCard: PropTypes.func,
// }

export default CreditPayment
